import React, { createContext, useReducer, useContext } from "react";
import { LiferayService } from "../../../common/services/liferay/index";
import { ApplicationPropertiesContext } from "../../../common/context/ApplicationPropertiesProvider";
import { getSignedIdStatus, decode_utf8 } from "../../../common/utils/utilsFunc";
import { AccessTokenContext } from "../../../common/context/AccessTokenProvider";


export const IngressoRectAndSolicitContext = createContext();

export const ACTIONS = {
  SET_IDCLIENT: "SET_IDCLIENT",
  SET_ERROR: "SET_ERROR",
  SET_IDLIST: "SET_IDLIST",
  SET_LOAD_PAGE: "SET_LOAD_PAGE", 
  SET_COMUNA: "SET_COMUNA",
  SET_ALL_COMUNA: "SET_ALL_COMUNA",
  SET_DETAIL_CLIENT: "SET_DETAIL_CLIENT",
  SET_FORMCONT: "SET_FORMCONT",
  SET_RESPONSE_FORMCONT: "SET_RESPONSE_FORMCONT",
  SET_RESPONSE_SERVICE: "SET_RESPONSE_SERVICE",
  SET_TAG_CURRENT_INTERACTION: "SET_TAG_CURRENT_INTERACTION",
  SET_LIST_INTERACTION: "SET_LIST_INTERACTION",
  SET_CTI: "SET_CTI",
  SET_CONFIRM_FORMCONT:"SET_CONFIRM_FORMCONT",
  SET_CODIGO_INTERACION_TO_COST:"SET_CODIGO_INTERACION_TO_COST",
  SET_VALUE_COST: "SET_VALUE_COST",
  SET_WEB_CONTENT_TEXT_INFO: "SET_WEB_CONTENT_TEXT_INFO",
  SET_COMUNA_REGION: "SET_COMUNA_REGION",
  SET_USER_ATTRIBUTES: "SET_USER_ATTRIBUTES",
  SET_ID_REGION: "SET_ID_REGION",
};

const initialState = {
  comunaRegion: null,
  userAttributes: null,
  allRegion: null,
  idCliente: '',
  errorFetch: null,
  idList: [],
  loadPage: false,
  comuna: {},
  allComuna: {},
  detailClient: null,
  jsonForm:{},
  responseFormCont:null,
  responseService: '',
  tag: '',
  listInteraction: null,
  cti: '',
  confirmFormsCont: null,
  codigoInteraccion: null,
  valueCost: null,
  webContentTextInfo: "",
  idRegion: null,
};

const GetCompensationReducer = (state = initialState, action) => {
  switch (action.type) {
    case ACTIONS.SET_ID_REGION: {
        return {
            ...state,
            idRegion: action.payload
        };
    } 
    case ACTIONS.SET_USER_ATTRIBUTES: {
      return {
        ...state,
        userAttributes: action.payload,
      };
    }  
    case ACTIONS.SET_COMUNA_REGION: {
      return {
        ...state,
        comunaRegion: action.payload,
      };
    }  
    case ACTIONS.SET_IDCLIENT: {
      return {
        ...state,
        idCliente: action.payload,
      };
    }  
    case ACTIONS.SET_ERROR: {
      return {
        ...state,
        errorFetch: action.payload,
      };
    }
    case ACTIONS.SET_IDLIST: {
      return {
        ...state,
        idList: action.payload,
      };
    }
    case ACTIONS.SET_COMUNA: {
      return {
        ...state,
        comuna: action.payload,
      };
    }
    case ACTIONS.SET_ALL_COMUNA: {
      return {
        ...state,
        allComuna: action.payload,
      };
    }
    case ACTIONS.SET_DETAIL_CLIENT: {
      return {
        ...state,
        detailClient: action.payload,
      };
    }
    case ACTIONS.SET_FORMCONT: {
      return {
        ...state,
        jsonForm: action.payload,
      };
    }
    case ACTIONS.SET_CONFIRM_FORMCONT: {
      return {
        ...state,
        confirmFormsCont: action.payload,
      };
    }
    case ACTIONS.SET_RESPONSE_FORMCONT: {
      return {
        ...state,
        responseFormCont: action.payload,
      };
    }
    case ACTIONS.SET_RESPONSE_SERVICE: {
      return {
        ...state,
        responseService: action.payload,
      };
    }
    case ACTIONS.SET_TAG_CURRENT_INTERACTION: {
      return {
        ...state,
        tag: action.payload,
      };
    }
    case ACTIONS.SET_LIST_INTERACTION: {
      return {
        ...state,
        listInteraction: action.payload,
      };
    }
    case ACTIONS.SET_CODIGO_INTERACION_TO_COST: {
      return {
        ...state,
        codigoInteraccion: action.payload,
      };
    }
    case ACTIONS.SET_VALUE_COST: {
      return {
        ...state,
        valueCost: action.payload,
      };
    }
    case ACTIONS.SET_LOAD_PAGE: {
      return {
        ...state,
        loadPage: action.payload,
      };
    }
    case ACTIONS.SET_CTI: {
      return {
        ...state,
        cti: action.payload,
      };
    }
    case ACTIONS.SET_WEB_CONTENT_TEXT_INFO: {
      return {
        ...state,
        webContentTextInfo: action.payload,
      };
    }
    default: {
      return state;
    }
  }
};

const IngressoRectAndSolicitContextProvider = ({ children }) => {
  const properties = useContext(ApplicationPropertiesContext);
  const [state, dispatch] = useReducer(GetCompensationReducer, initialState);
  const { accessToken } = useContext(AccessTokenContext);

  React.useEffect(() => {
    if(accessToken){

      LiferayService.getIdList(properties.base_url_api)
      .then((response) => {
        dispatch({
            payload: response,
            type: ACTIONS.SET_IDLIST,
          });
          dispatch({
            payload: null,
            type: ACTIONS.SET_ERROR,
          });
        })
        .catch((error) => {
          dispatch({
            payload: error,
            type: ACTIONS.SET_ERROR,
          });
        })
    }
  },[accessToken])

  React.useEffect(() => {
      
      if(accessToken) {
          LiferayService.getUserAttributes(properties.base_url_api)
              .then((response) => {
                  dispatch({
                      payload: response,
                      type: ACTIONS.SET_USER_ATTRIBUTES,
                  });
                  dispatch({
                      payload: null,
                      type: ACTIONS.SET_ERROR,
                  });
          })
          .catch((error) => {
                  dispatch({
                      payload: error,
                      type: ACTIONS.SET_ERROR,
                  });
          })
          dispatch({
              payload: null,
              type: ACTIONS.SET_ERROR,
          });
      }

  }, [accessToken])
 

  React.useEffect(() => {
    if (state.loadPage) {
      LiferayService.getComuna(properties.base_url_api, properties.codigo_empresa)
        .then((response) => {
            dispatch({
              payload: response,
              type: ACTIONS.SET_COMUNA,
            });
          })
        .catch((error) => {
          dispatch({
            payload: error,
            type: ACTIONS.SET_ERROR,
          });
        })
        LiferayService.getAllComunas(properties.base_url_api)
        .then((response) => {
            dispatch({
              payload: response,
              type: ACTIONS.SET_ALL_COMUNA,
            });

            LiferayService.getUserAttributes(properties.base_url_api)
                .then((response) => {
                    dispatch({
                        payload: response,
                        type: ACTIONS.SET_USER_ATTRIBUTES,
                    });
                    dispatch({
                        payload: null,
                        type: ACTIONS.SET_ERROR,
                    });
            })
            .catch((error) => {
                    dispatch({
                        payload: error,
                        type: ACTIONS.SET_ERROR,
                    });
            })
            dispatch({
                payload: null,
                type: ACTIONS.SET_ERROR,
            });
            
            dispatch({
              payload: false,
              type: ACTIONS.SET_LOAD_PAGE,
            });
          })
        .catch((error) => {
          dispatch({
            payload: error,
            type: ACTIONS.SET_ERROR,
          });
        })
    if (decode_utf8(properties.web_content_info_update_of_contact_information).trim()) {
      LiferayService.getWebContent(properties.base_url_api, decode_utf8(properties.web_content_info_update_of_contact_information).trim())
        .then((response) => {
          dispatch({
            payload: response,
            type: ACTIONS.SET_WEB_CONTENT_TEXT_INFO,
          });
        })
      }
    }
  }, [state.loadPage]);

  React.useEffect(() => {
    if(state.tag){
      LiferayService.getListTipoInteracciones(properties.base_url_api, state.tag, properties.codigo_empresa)
      .then((response) => {
          dispatch({
            payload: response,
            type: ACTIONS.SET_LIST_INTERACTION,
          });
        })
      .catch((error) => {
        dispatch({
          payload: error,
          type: ACTIONS.SET_ERROR,
        });
      })
    }
  }, [state.tag])

  

  React.useEffect(() => {
    if(state.idCliente){
      if(state.responseService){
        dispatch({
          payload: '',
          type: ACTIONS.SET_RESPONSE_SERVICE,
        });
      }
      LiferayService.consultarEstadoServicio(properties.base_url_api, state.idCliente, properties.url_ws_empresa)
      .then((response) =>{
        if(response.code === 0){
          dispatch({
            payload: '',
            type: ACTIONS.SET_RESPONSE_SERVICE,
          });
        } else {
          dispatch({
            payload: response?.mensaje,
            type: ACTIONS.SET_RESPONSE_SERVICE,
          });
        }
      })
      LiferayService.consultarDetalleCuentaContrato(properties.base_url_api,state.idCliente, properties.url_ws_empresa, properties.codigo_empresa)
      .then((response) =>{
        dispatch({
            payload: response,
            type: ACTIONS.SET_DETAIL_CLIENT,
          });
          dispatch({
            payload: null,
            type: ACTIONS.SET_ERROR,
          });
        })
      .catch((error) => {
        dispatch({
          payload: error,
          type: ACTIONS.SET_ERROR,
        });
      })
    }
  },[state.idCliente])

  React.useEffect(() => {
    if(Object.keys(state.jsonForm).length !== 0){
      if(state.tag === "RI"){
        LiferayService.createTicketReclamo(properties.base_url_api, properties.url_ws_empresa, state.jsonForm, getSignedIdStatus(), properties.reclamo_edelmag_content_correo)
        .then((response) => {
          dispatch({
            payload: response,
            type: ACTIONS.SET_RESPONSE_FORMCONT,
          });
          dispatch({
            payload: null,
            type: ACTIONS.SET_ERROR,
          });
        })
        .catch((error) => {
          dispatch({
            payload: error,
            type: ACTIONS.SET_ERROR,
        });
      })
      }
      
      if(state.tag === "RC"){
        LiferayService.createTicketReclamoComercialOrSolicitud(properties.base_url_api, state.jsonForm[0], state.jsonForm[1])
        .then((response) => {
          dispatch({
            payload: response,
            type: ACTIONS.SET_RESPONSE_FORMCONT,
          });
          dispatch({
            payload: null,
            type: ACTIONS.SET_ERROR,
          });
        })
        .catch((error) => {
          dispatch({
            payload: error,
            type: ACTIONS.SET_ERROR,
        });
      })
      }
    }

  }, [state.jsonForm])

  React.useEffect(() => {
    if( state.tag === "SO"){
      LiferayService.createTicketReclamoComercialOrSolicitud(properties.base_url_api, state.jsonForm)
        .then((response) => {
          dispatch({
            payload: response,
            type: ACTIONS.SET_RESPONSE_FORMCONT,
          });
          dispatch({
            payload: null,
            type: ACTIONS.SET_ERROR,
          });
        })
        .catch((error) => {
          dispatch({
            payload: error,
            type: ACTIONS.SET_ERROR,
        });
      })
    }
  }, [state.jsonForm])

  React.useEffect(() => {
    if(state.codigoInteraccion){
      LiferayService.getPrecioMaterial(properties.base_url_api, properties.codigo_empresa,state.codigoInteraccion)
      .then((response) => {
        dispatch({
          payload: response,
          type: ACTIONS.SET_VALUE_COST,
        });
        dispatch({
          payload: null,
          type: ACTIONS.SET_ERROR,
        });
      })
      .catch((error) => {
        dispatch({
          payload: error,
          type: ACTIONS.SET_ERROR,
      });
      })
    }
  },[state.codigoInteraccion])
  
  return (
    <IngressoRectAndSolicitContext.Provider value={[state, dispatch]}>
      {children}
    </IngressoRectAndSolicitContext.Provider>
  );
};
export default IngressoRectAndSolicitContextProvider;
